import React from 'react';

import { AnimatePresence } from 'framer-motion';

import { useAppSelector } from '@pkg/hooks';
import { type WalletCollectiblesBalance } from '@pkg/types';

import { type ActiveListingDetails, type CollectionChainType, SupportedTokens } from '@app/client';
import { useNFTsPageStore } from '@app/store/zustand';

import { CurrencyIcon } from './CurrencyIcon';
import { MarketplaceButton } from './MarketplaceButton';
import { NFTManagerControls } from './NFTManagerControls';
import { SelectedButton } from './SelectedButton';

import { Wrapper } from './styles';

interface CardMarketplaceControlsProps {
    nftItem: WalletCollectiblesBalance;
    isHovering?: boolean;
    chain?: CollectionChainType;
    item_id?: string;
    isOwner?: boolean;
    onBuyNow: () => void;
}

export const CardMarketplaceControls = ({
    nftItem,
    chain,
    item_id,
    isOwner,
    isHovering,
    onBuyNow,
}: CardMarketplaceControlsProps) => {
    const { selectedItems, listingData } = useNFTsPageStore();
    const marketplaceEnabled = useAppSelector((state) => state.featureFlags.features.marketplaceEnabled);
    const isSelected = selectedItems.includes(item_id || '');
    const listingDetails = listingData?.[SupportedTokens[chain || 'ethereum']]?.details;
    const isListed = listingDetails?.find(
        (item: ActiveListingDetails) =>
            item?.token_id === nftItem.token_id && nftItem.collection?.includes(item?.contract_address),
    );

    return (
        <AnimatePresence initial={false}>
            <Wrapper $isHovering={isHovering}>
                {isHovering && <CurrencyIcon chain={chain} />}

                {(isHovering || isSelected) && marketplaceEnabled && (
                    <SelectedButton item_id={item_id} isSelected={isSelected} />
                )}

                {isHovering && (
                    <>
                        {!isOwner ? (
                            <>
                                {marketplaceEnabled && (
                                    <MarketplaceButton isListed={isListed} onBuyNow={onBuyNow || null} />
                                )}
                            </>
                        ) : (
                            <NFTManagerControls chain={chain} nftItem={nftItem} isListed={isListed} />
                        )}
                    </>
                )}
            </Wrapper>
        </AnimatePresence>
    );
};
